export const VALID_CHARS = [
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P',
    'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',
    'Z', 'X', 'C', 'V', 'B', 'N', 'M', '_',
]
